var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getImage(_vm.config, _vm.lang))?_c('preview',{attrs:{"preview-id":_vm.getImage(_vm.config, _vm.lang),"source":"asset","asset-id":_vm.getImage(_vm.config, _vm.lang),"removable":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }